<template>
  <b-dropdown variant="primary" class="dropdown-selector">
    <template v-slot:button-content>
      <template v-if="display_area">
        {{ $t("menu." + display_area.toLowerCase()) }}
      </template>
      <template v-else>-----</template>
    </template>

    <div class="dropdown-select-area">
      <b-dropdown-item
        v-for="(station, idx_station) in area_list"
        :key="'station-' + +idx_station"
        :active="display_area.toLowerCase() == station.toLowerCase()"
        @click="update_selected(station.toLowerCase())"
      >
        {{ $t("menu." + station.toLowerCase()) }}
      </b-dropdown-item>
    </div>
  </b-dropdown>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {},
  data() {
    return {
      stations_in_area: [],
    };
  },
  mounted() {
    // this.update_selected(this.area_code[0]);
  },
  computed: {
    ...mapState({
      display_area: (state) => state.data.display_area,
      area_list: (state) => state.data.area_list,
      station_list: (state) => state.data.stations_info,
    }),
  },
  methods: {
    update_selected(area_code) {
      this.$store.commit("data/select_area", area_code);
      // this.stations_in_area = this.station_list.map(
      //   (_s) => _s.area.toLowerCase() == area_code.toLowerCase()
      // );
      // this.$emit("stations", this.stations_in_area);
    },
  },
};
</script>

<style lang="scss">
.dropdown-selector {
  .location-name {
    color: #fe6357;
  }

  .dropdown-toggle {
    border-radius: 5px 50px 50px 5px !important;
  }
}
</style>
